import React from "react";
import styled from "styled-components";
import { TabButton } from "@sonder/ui/source/styled/fragments/TabButton";
import { TabGroup } from "@sonder/ui/source/styled/fragments/TabGroup";
import { colors } from "@sonder/ui/source/styled/theme";
import { useCanCreateBulkTasks } from "tasks/hooks/useCanCreateBulkTasks";
import {
  BulkFormTabs,
  SubjectTypeAndBulkFormTabLabel,
  SubjectTypeConfig,
} from "tasks/hooks/useCreateTaskFormConfig";
import { TaskContextSubjectTypeEnum } from "typings/globalGQLTypes";

const StyledTabGroup = styled(TabGroup)`
  padding: 0 1.71rem;
`;

const StyledTabButton = styled(TabButton)`
  border-bottom-color: ${props => props.selected && colors.blue7};

  &:hover:not(:disabled) {
    border-bottom-color: ${props => !props.selected && colors.grayE};
  }

  &:active:not(:disabled) {
    border-bottom-color: ${props => !props.selected && colors.blueA};
  }
`;

interface OnChangeProps {
  tab: BulkFormTabs;
  parentSubjectType?: TaskContextSubjectTypeEnum;
}

interface Props {
  disabled?: boolean;
  onChange?: (props: OnChangeProps) => void;
  selectedTab?: BulkFormTabs;
  subjectType?: SubjectTypeConfig;
}

export const TaskSubjectBulkTabs = ({
  disabled,
  onChange,
  selectedTab,
  subjectType,
}: Props) => {
  const { canCreateBulkTasks } = useCanCreateBulkTasks();
  const isBulkTaskCreationSupported =
    canCreateBulkTasks && subjectType?.bulkTaskConfig;
  const parentSubjectType = subjectType?.bulkTaskConfig?.parentSubjectType;
  const supportedTabs = subjectType?.bulkTaskConfig?.supportedTabs || [];
  const labels =
    subjectType?.subjectType &&
    SubjectTypeAndBulkFormTabLabel[subjectType?.subjectType];

  if (!isBulkTaskCreationSupported) return null;
  if (!supportedTabs.length) return null;

  return (
    <StyledTabGroup>
      {supportedTabs.map(tab => {
        const isSelected = selectedTab
          ? selectedTab === tab
          : BulkFormTabs.Single === tab;
        const label = labels && labels[tab];

        if (!label) return null;

        return (
          <StyledTabButton
            disabled={disabled}
            key={tab}
            selected={isSelected}
            onClick={() => {
              if (onChange) onChange({ tab, parentSubjectType });
            }}
          >
            {label}
          </StyledTabButton>
        );
      })}
    </StyledTabGroup>
  );
};
